<template>
  <div id="v-widget" class="v-widget-modern">
    <v-card class="widget-card">
      <div v-if="enableHeader" class="widget-header">
        <h4 class="widget-header__title">{{ title }}</h4>
        <div class="widget-header__actions">
          <slot name="widget-header-action"></slot>
        </div>
      </div>
      <v-divider v-if="enableHeader" class="widget-divider"></v-divider>
      <v-card-text :class="contentBg" class="widget-content">
        <slot name="widget-content"></slot>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "v-widget",
  props: {
    title: { type: String },
    enableHeader: { type: Boolean, default: true },
    contentBg: { type: String, default: "white" }
  },
  data() {
    return {};
  },
  computed: {}
};
</script>

<style scoped lang="css">
.widget-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
}

.widget-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.2px;
}

.widget-header__actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.widget-divider {
  border-color: #f1f5f9 !important;
}

.widget-content {
  padding: 20px !important;
}
</style>
